import { CommonModule, DatePipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgIvsModule } from '@cotufa82/ng-ivs';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { faCommentSms } from '@fortawesome/free-solid-svg-icons';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MentionModule } from 'angular-mentions';
import { NgxAudioPlayerModule } from '@khajegan/ngx-audio-player';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { ImageCropperModule } from 'ngx-image-cropper';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
import { NgOtpInputModule } from 'ng-otp-input';
import { AlertModalComponent } from '@components/alert-modal/alert-modal.component';
import { ButtonComponent } from '@components/button/button.component';
import { SkeletonComponent } from '@components/skeleton/skeleton.component';
import { TableSkeletonComponent } from '@components/skeleton/table-skeleton/table-skeleton.component';
import { CardGridSkeletonComponent } from '@components/skeleton/card-grid-skeleton/card-grid-skeleton.component';
import { SearchBarV2Component } from '@components/search-bar/search-bar.component';
import { NftUnlockModalComponent } from '@components/nft-unlock-modal/nft-unlock-modal.component';
import { ProfileDetailComponent } from '@components/profile-detail/profile-detail.component';
import { SubscriptionPlanDurationModalComponent } from '@components/subscription-plan-duration-modal/subscription-plan-duration-modal.component';
import { SubscriptionSelectModalComponent } from '@components/subscription-select-modal/subscription-select-modal.component';
import { shareProp } from '@constants/share-button-constant';
import { EventListItemComponent } from '@modules/dashboard/components/event-list-item/event-list-item.component';
import { AtHashtagComponent } from '@modules/dashboard/components/new-post/at-hashtag/at-hashtag.component';
import { AtTaggingUserComponent } from '@modules/dashboard/components/new-post/at-tagging-user/at-tagging-user.component';
import { UnlockContentComponent } from '@shared/components/unlock-content/unlock-content.component';
import { PortfolioUnlockModalComponent } from '@shared/components/portfolio-unlock-modal/portfolio-unlock-modal.component';
import { BlockConfirmDialogComponent } from '@shared/components/block-confirm-dialog/block-confirm-dialog.component';
import { CancelConfirmDialogComponent } from '@shared/components/cancel-confirm-dialog/cancel-confirm-dialog.component';
import { CourseDetailSidebarComponent } from '@shared/components/course-detail-sidebar/course-detail-sidebar.component';
import { DialogBoxComponent } from '@shared/components/dialog-box/dialog-box.component';
import { FollowDialogComponent } from '@shared/components/follow-dialog/follow-dialog.component';
import { FollowersComponent } from '@shared/components/followers/followers.component';
import { FollowingsComponent } from '@shared/components/followings/followings.component';
import { FooterComponent } from '@shared/components/footer/footer.component';
import { HeaderComponent } from '@shared/components/header/header.component';
import { HeaderUserMenuComponent } from '@shared/components/header-user-menu/header-user-menu.component';
import { LanguageSwitcherComponent } from '@components/language-switcher/language-switcher.component';
import { ImageCropperComponent } from '@shared/components/image-cropper/image-cropper.component';
import { LoaderComponent } from '@shared/components/loader/loader.component';
import { LockedDialogComponent } from '@shared/components/locked-dialog/locked-dialog.component';
import { LoginDialogComponent } from '@shared/components/login-dialog/login-dialog.component';
import { OrderConfirmationComponent } from '@shared/components/order-confirmation/order-confirmation.component';
import { OrderPaymentComponent } from '@shared/components/order-payment/order-payment.component';
import { PaymentIntentCheckoutComponent } from '@shared/components/payment-intent-checkout/payment-intent-checkout.component';
import { OrderPaymentSkeletonComponent } from '@shared/components/order-payment/skeleton/order-payment-skeleton.component';
import { PostLikesComponent } from '@shared/components/post-likes/post-likes.component';
import { PostSubscriptionListPopupComponent } from '@shared/components/post-subscription-list-popup/post-subscription-list-popup.component';
import { ProfileSidebarComponent } from '@shared/components/profile-sidebar/profile-sidebar.component';
import { ProfileComponent } from '@shared/components/profile/profile.component';
import { ReportDailogComponent } from '@shared/components/report-dailog/report-dailog.component';
import { RestrictBasicInfoDialogComponent } from '@shared/components/restrict-basic-info-dialog/restrict-basic-info-dialog.component';
import { RightSidebarComponent } from '@shared/components/right-sidebar/right-sidebar.component';
import { SearchBarComponent } from '@shared/components/search-bar/search-bar.component';
import { SearchedPostListComponent } from '@shared/components/searched-post-list/searched-post-list.component';
import { SendtipdialogComponent } from '@shared/components/sendtipdialog/sendtipdialog.component';
import { ShareddialogComponent } from '@shared/components/shareddialog/shareddialog.component';
import { ShippingOptionsComponent } from '@shared/components/shipping-options/shipping-options.component';
import { ShowCollabsComponent } from '@shared/components/show-collabs/show-collabs.component';
import { SidebarComponent } from '@shared/components/sidebar/sidebar.component';
import { CoursesDetailsComponent } from '@shared/components/store-details/courses-details/courses-details.component';
import { CustomizeExperienceComponent } from '@shared/components/store-details/customize-experience/customize-experience.component';
import { TicketCustomerInformationComponent } from '@shared/components/store-details/ticket-checkout/ticket-customer-information.component';
import { ScheduleExperienceComponent } from '@shared/components/store-details/schedule-experience/schedule-experience.component';
import { ExperiencesDetailsComponent } from '@shared/components/store-details/experiences-details/experiences-details.component';
import { MerchandiseDetailsComponent } from '@shared/components/store-details/merchandise-details/merchandise-details.component';
import { StripeFormComponent } from '@shared/components/stripe-form/stripe-form.component';
import { SubscriptionUpgradeDialogComponent } from '@shared/components/subscription-upgrade-dialog/subscription-upgrade-dialog.component';
import { TaxonomyDetailComponent } from '@shared/components/taxonomy-detail/taxonomy-detail.component';
import { UnfollowDialogComponent } from '@shared/components/unfollow-dialog/unfollow-dialog.component';
import { BadgeDetailModalComponent } from '@shared/components/badge-detail-modal/badge-detail-modal.component';
import { UnlockNftComponent } from '@shared/components/unlock-nft/unlock-nft.component';
import { UserImageComponent } from '@shared/components/user-image/user-image.component';
import { UserProfileComponent } from '@shared/components/user-profile/user-profile.component';
import { VideoPlayerV2Component } from '@shared/components/video-player-v2/video-player-v2.component';
import { VideoPlayerComponent } from '@shared/components/video-player/video-player.component';
import { WhiteLabelDialogBoxComponent } from '@shared/components/white-label-dialog/white-label-dialog.component';
import { ModalExtention } from '@shared/directive/modal-extention.directive';
import { NoSpaceDirective } from '@shared/directive/no-space.directive';
import { TwoDigitDecimaNumberDirective } from '@shared/directive/number-decimal.directive';
import { AudioPlayer } from '@shared/pipes/audio-player.pipe';
import { BlockedUserStatus } from '@shared/pipes/blocked-users.pipe';
import {
  BioFormatPipe,
  BioLinkPipe,
  MakeTagTextPipe,
  MakeTagTextWithAdminTagPipe
} from '@shared/pipes/cast-link.pipe';
import { ContentLengthHandlerPipe } from '@shared/pipes/content-length-handler.pipe';
import { CustomSlicePipe } from '@shared/pipes/custom-slice.pipe';
import { ConvertDate } from '@shared/pipes/date-substract.pipe';
import { FilterPipe } from '@shared/pipes/filter.pipe';
import { FluidHeightPipe } from '@shared/pipes/fluidheight.pipe';
import { FollowStatus } from '@shared/pipes/follow-status.pipe';
import { isPostCollaboratorPipe } from '@shared/pipes/is-post-collaborator.pipe';
import { CheckIsURL, RemoveURLS, SafeUrl } from '@shared/pipes/isLink.pipe';
import { PostLiked } from '@shared/pipes/like-count.pipe';
import { MyProfile } from '@shared/pipes/my-profile.pipe';
import { LinkifyPipe } from '@shared/pipes/linkify.pipe';
import { PollAnswered } from '@shared/pipes/poll-answered.pipe';
import { PriceDiscountPipe } from '@shared/pipes/price-discount.pipe';
import { PostScheduled, ScheduleTime } from '@shared/pipes/schedule_time.pipe';
import { TimerFormat, UserTimeZone } from '@shared/pipes/timer-format.pipe';
import { UserNameToLink } from '@shared/pipes/user-link.pipe';
import { VideoOption } from '@shared/pipes/video-src.pipe';
import { HasPermissionPipe } from '@shared/pipes/has-permission.pipe';
import { IntersectionObserverDirective } from '@shared/directive/intersection-observer.directive';
import { ReadMoreDirective } from '@shared/directive/readMore.directive';
import { MobileBridgeFileInputDirective } from '@shared/directive/mobile-bridge-file-input.directive';
import { LoginOrGuestDialogComponent } from '@shared/components/login-or-guest-dialog/login-or-guest-dialog.component';
import { GiveawayAnswerModal } from '@modules/dashboard/components/giveaway-answer-modal/giveaway-answer-modal.component';
import { GiveawayResponseModal } from '@shared/components/giveaway-response-modal/giveaway-response-modal.component';
import { InfoIconComponent } from '@components/info-icon/info-icon.component';
import { SubscriptionEndModalComponent } from '@shared/components/subscription-end-modal/subscription-end-modal.component';
import { PluralizePipe } from '@shared/pipes/pluralize.pipe';
import { InfoModalComponent } from '@components/info-modal/info-modal.component';
import { TickIconComponent } from '@components/tick-icon/tick-icon.component';
import { SharedPhoneMaskDirective } from '@modules/shared/directive/shared-phone-mask.directive';
import { NotificationFollowingDialogComponent } from '@shared/components/notification-following-dialog/notification-following-dialog.component';
import { TabViewComponent } from '@components/tab-view/tab-view.component';
import { DynamicListingComponent } from '@components/dynamic-listing/dynamic-listing.component';
import { FormTextAreaComponent } from '@modules/dynamic-form-builder/components/text-area/text-area.component';
import { IsCollaboratedUserPipe } from '@shared/pipes/is-collaboarted-user.pipe';
import { TranslateDirective } from '@shared/directive/translate.directive';
import { CreatorRequirementsModalComponent } from '@modules/edit-preference/become-a-creator/components/creator-requirements-modal/creator-requirements-modal.component';
import { CheckboxComponent } from '@modules/dynamic-form-builder/components/checkbox/checkbox.component';
import { HasArrayValuePipe } from '@shared/pipes/has-array-value.pipe';
import { PostSubmitComponent } from '@modules/dashboard/components/new-post/newposts/post-submit/post-submit.component';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { CurrencyConversionPipe } from '@shared/pipes/currency-conversion.pipe';
import { DownloadableDetailsComponent } from '@shared/components/store-details/downloadable-details/downloadable-details.component';
import { ScheduleComponent } from '@modules/dashboard/components/new-post/dialog-box/schedule/schedule.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { MobileOptimizationDirective } from '@app-shared/directives/mobile-optimization.directive';

import { VideoPlayerV3Component } from '@modules/shared/components/video-player-v3/video-player-v3.component';
import { DisableRightClickDirective } from '@modules/shared/directive/disable-right-click.directive';
import { AudioSliderPatchDirective } from '@modules/shared/directive/audio-slider-patch.directive';
import { SpaLinkDirective } from '@modules/shared/directive/spa-link.directive';
import { ScrollContainerLoaderDirective } from '@modules/shared/directive/scroll-container-loader.directive';
import { ToolTipDirective } from '@shared/directive/tool-tip.directive';
import { ConfirmationModalComponent } from '@components/confirmation-modal/confirmation-modal.component';
import { CustomMultiSelectComponent } from '@modules/dynamic-form-builder/components/custom-mutliselect/custom-multiselect.component';
import { VerifyOTPModalComponent } from '@modules/edit-preference/components/verify-otp-modal/verify-otp-modal.component';
import { ImageOverlayComponent } from '@modules/shared/components/image-overlay/image-overlay.component';
import { MobileInputComponent } from '@modules/dynamic-form-builder/components/mobile-input/mobile-input.component';
import { CustomWelcomeModalTemplate } from '@modules/shared/components/welcome-video-modal/welcome-video-modal.component';
import { WelcomeVideoPostComponent } from '@modules/shared/components/welcome-video-post/welcome-video-post.component';
import { PostCardComponent } from '@shared/components/post-card/post-card.component';
import { PostCardFooterComponent } from '@shared/components/post-card/components/post-card-footer/post-card-footer.component';
import { PostCardStatsComponent } from '@shared/components/post-card/components/post-card-stats/post-card-stats.component';
import { SensitiveOverlayComponent } from '@shared/components/post-card/components/sensitive-overlay/sensitive-overlay.component';
import { LockedOverlayComponent } from '@shared/components/post-card/components/locked-overlay/locked-overlay.component';
import { PhoneMaskDirective } from '@modules/dynamic-form-builder/directive/phone-mask.directive';
import { CircleBackgroundIconComponent } from '@components/circle-background-icon/circle-background-icon.component';
import { VenueAddressDisplayComponent } from '@components/venue-address-display/venue-address-display.component';
import { CommentsComponent } from '@components/comments/comments.component';
import { LikeShareBarComponent } from '@components/like-share-bar/like-share-bar.component';
import { AbbreviateNumberPipe } from '@shared/pipes/abbreviate-number.pipe';
import { BookDemoComponent } from '@components/book-demo/book-demo.component';
import { DynamicFormBuilderModule } from '@modules/dynamic-form-builder/dynamic-form-builder.module';
import { DiscountCodeModal } from '@shared/components/coupen-code-modal/coupen-code-modal.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { TextEditorV2Component } from '@components/text-editor-v2/text-editor-v2.component';
import { WatermarkControlsComponent } from '@modules/dashboard/components/new-post/newposts/watermark-controls/watermark-controls.component';
import { MerchandiseShareModalComponent } from '@shared/components/merchandsie-share-modal/merchandise-share-modal.component';
import { CustomBenefitsModalComponent } from '@shared/components/custom-benefits-modal/custom-benefits-modal.component';
import { ShareDetialsPreviewComponent } from '@shared/components/share-details-preview/share-details-preview.component';
import { CameraModalComponent } from '@components/camera-modal/camera-modal.component'
import { ChatCommentsComponent } from '@components/chat-comments/chat-comments.component';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { MinimumTipComponent } from '@modules/edit-preference/components/minimum-tip/minimum-tip.component';
import { FeedContentShareModalComponent } from '@shared/components/feed-content-share-modal/feed-content-share-modal.component';
import { EventTicketingShareModalComponent } from '@shared/components/event-ticketing-share-modal/event-ticketing-share-modal.component';
import { VipOfferShareModalComponent } from '@shared/components/vip-offer-share-modal/vip-offer-share-modal.component';
import { FundraiserProgressSectionComponent } from '@shared/components/fundraiser-progress-section/fundraiser-progress-section.component';
import { PostAudioIconComponent } from '@components/post-audio-icon/post-audio-icon.component';
import { PaymentSuccessfulModalComponent } from '@shared/components/payment-successful-modal/payment-successful-modal.component';
import { ItemClaimedModalComponent } from '@shared/components/item-claimed-modal/item-claimed-modal.component';
import { FundContributeModalComponent } from '@shared/components/fund-contribute-modal/fund-contribute-modal.component';
import { ViewContributorsModalComponent } from '@shared/components/view-contributors-modal/view-contributors-modal.component';
import { UserGroupsModalComponent } from '@shared/components/user-groups-modal/user-groups-modal.component';
import { GiftDetailsModalComponent } from '@shared/components/gift-details-modal/gift-details-modal.component';
import { PollOptionsComponent } from '@modules/shared/components/poll-options/poll-options.component';
import { SponsoredAdComponent } from '@components/sponsored-ad/sponsored-ad.component';
import { UpcomingEventCountdownComponent } from '@components/upcoming-event-countdown/upcoming-event-countdown.component';
import { SkyscraperPreviewModalComponent } from '@components/skyscraper-preview-modal/skyscraper-preview-modal.component';
import { TopicTagsSelectionComponent } from '@modules/shared/components/topic-tags-selection/topic-tags-selection.component';
import { BadgeGroupsSelectionComponent } from '@modules/shared/components/badge-groups-selection/badge-groups-selection.component';
import { UserTypeSelectionModalComponent } from '@modules/shared/components/user-type-selection-modal/user-type-selection-modal.component';
import { CapitalizeFirstPipe } from '@modules/shared/pipes/capitalizeFirst.pipe';
import { ShowTabByApprovalPipe } from '@modules/shared/pipes/show-tab-by-approval.pipe';
import { AddressFormattingPipe } from '@modules/shared/pipes/address-formatting.pipe';
import { PortfolioShareModalComponent } from '@shared/components/portfolio-share-modal/portfolio-share-modal.component';
import { CurrencyToLocal } from '@shared/pipes/convertCurrencyToLocal.pipe'
import { PriceDisplayComponent } from '@components/currency-conversion/currency-conversion.component'
import { IsDeductionTransactionPipe } from '@shared/pipes/is-deduction-txn.pipe'
import {
  CurrencyConversionModalComponent
} from '@components/currency-conversion-modal/currency-conversion-modal.component';
import { TicketDetailsDisplayComponent } from '@shared/components/ticket-details-display/ticket-details-display.component';
import { TicketViewModalComponent } from '@shared/components/ticket-details-display/ticket-view-modal/ticket-view-modal.component';
import { PurchasePointsModalComponent } from '@modules/wallet/component/loyalty-points/purchase-points-modal/purchase-points-modal.component';
import { UnlockWithPointsModalComponent } from '@components/unlock-with-points-modal/unlock-with-points-modal.component';
import { LoyaltyOnlyWarningModalComponent } from '@components/loyalty-only-warning-modal/loyalty-only-warning-modal.component';
import { EventTicketingSkeletonComponent } from '@components/skeleton/event-ticketing-skeleton/event-ticketing-skeleton.component';
import { MerchandiseDetailsSkeletonComponent } from '@components/skeleton/merchandise-details-skeleton/merchandise-details-skeleton.component';
import { ResourceCardGridSkeletonComponent } from '@components/skeleton/resource-card-grid-skeleton/resource-card-grid-skeleton.component';
import { GiftDetailsSkeletonComponent } from '@components/skeleton/gift-details-skeleton/gift-details-skeleton.component';
import { ProfileSkeletonComponent } from '@components/skeleton/profile-skeleton/profile-skeleton.component';
import { RightSidebarSkeletonComponent } from '@components/skeleton/right-sidebar-skeleton/right-sidebar-skeleton.component';
import { FollowersFollowingsSkeletonComponent } from '@components/skeleton/followers-followings-skeleton/followers-followings-skeleton.component';

@NgModule({
  declarations: [
    LoginOrGuestDialogComponent,
    HeaderComponent,
    HeaderUserMenuComponent,
    SidebarComponent,
    RightSidebarComponent,
    UserImageComponent,
    UserProfileComponent,
    ProfileSidebarComponent,
    LoaderComponent,
    ConvertDate,
    DialogBoxComponent,
    WhiteLabelDialogBoxComponent,
    FollowDialogComponent,
    SendtipdialogComponent,
    ShareddialogComponent,
    PostLiked,
    AudioPlayer,
    FollowStatus,
    UnfollowDialogComponent,
    BadgeDetailModalComponent,
    PollAnswered,
    StripeFormComponent,
    MyProfile,
    isPostCollaboratorPipe,
    ProfileComponent,
    LoginDialogComponent,
    PostSubscriptionListPopupComponent,
    BioLinkPipe,
    CustomSlicePipe,
    CourseDetailSidebarComponent,
    CoursesDetailsComponent,
    ExperiencesDetailsComponent,
    MerchandiseDetailsComponent,
    TwoDigitDecimaNumberDirective,
    FollowersComponent,
    FollowingsComponent,
    OrderPaymentComponent,
    PaymentIntentCheckoutComponent,
    OrderConfirmationComponent,
    CustomizeExperienceComponent,
    TicketCustomerInformationComponent,
    ScheduleExperienceComponent,
    BioFormatPipe,
    MakeTagTextPipe,
    MakeTagTextWithAdminTagPipe,
    VideoPlayerComponent,
    VideoPlayerV2Component,
    VideoPlayerV3Component,
    VideoOption,
    UserNameToLink,
    BlockConfirmDialogComponent,
    SearchBarComponent,
    SearchedPostListComponent,
    ReportDailogComponent,
    ScheduleTime,
    PostScheduled,
    PostLikesComponent,
    ShowCollabsComponent,
    RestrictBasicInfoDialogComponent,
    LockedDialogComponent,
    NoSpaceDirective,
    BlockedUserStatus,
    FluidHeightPipe,
    UnlockNftComponent,
    AtTaggingUserComponent,
    AtHashtagComponent,
    CheckIsURL,
    ContentLengthHandlerPipe,
    FilterPipe,
    SafeUrl,
    SharedPhoneMaskDirective,
    UserTimeZone,
    SubscriptionUpgradeDialogComponent,
    CancelConfirmDialogComponent,
    RemoveURLS,
    TaxonomyDetailComponent,
    ShippingOptionsComponent,
    ModalExtention,
    EventListItemComponent,
    UnlockContentComponent,
    PortfolioUnlockModalComponent,
    IntersectionObserverDirective,
    ReadMoreDirective,
    GiveawayResponseModal,
    SubscriptionEndModalComponent,
    HasPermissionPipe,
    PluralizePipe,
    NotificationFollowingDialogComponent,
    TickIconComponent,
    TranslateDirective,
    CreatorRequirementsModalComponent,
    HasArrayValuePipe,
    PostSubmitComponent,
    IsCollaboratedUserPipe,
    CurrencyConversionPipe,
    DownloadableDetailsComponent,
    ScheduleComponent,
    LinkifyPipe,
    AudioSliderPatchDirective,
    SpaLinkDirective,
    ScrollContainerLoaderDirective,
    TimerFormat,
    VerifyOTPModalComponent,
    CustomWelcomeModalTemplate,
    WelcomeVideoPostComponent,
    PostCardComponent,
    PostCardFooterComponent,
    PostCardStatsComponent,
    SensitiveOverlayComponent,
    LockedOverlayComponent,
    CommentsComponent,
    LikeShareBarComponent,
    AbbreviateNumberPipe,
    DiscountCodeModal,
    WatermarkControlsComponent,
    MerchandiseShareModalComponent,
    CustomBenefitsModalComponent,
    ShareDetialsPreviewComponent,
    CameraModalComponent,
    ChatCommentsComponent,
    MinimumTipComponent,
    FeedContentShareModalComponent,
    EventTicketingShareModalComponent,
    VipOfferShareModalComponent,
    PortfolioShareModalComponent,
    FundraiserProgressSectionComponent,
    PaymentSuccessfulModalComponent,
    ItemClaimedModalComponent,
    FundContributeModalComponent,
    ViewContributorsModalComponent,
    UserGroupsModalComponent,
    GiftDetailsModalComponent,
    PollOptionsComponent,
    PurchasePointsModalComponent,
    UnlockWithPointsModalComponent,
    SponsoredAdComponent,
    UpcomingEventCountdownComponent,
    SkyscraperPreviewModalComponent,
    TopicTagsSelectionComponent,
    BadgeGroupsSelectionComponent,
    UserTypeSelectionModalComponent,
    CapitalizeFirstPipe,
    CurrencyConversionModalComponent,
    TicketDetailsDisplayComponent,
    TicketViewModalComponent,
    ShowTabByApprovalPipe,
    AddressFormattingPipe,
    CurrencyConversionModalComponent
  ],
  imports: [
    FooterComponent,
    MobileBridgeFileInputDirective,
    CheckboxComponent,
    GiveawayAnswerModal,
    InfoModalComponent,
    RouterModule,
    DynamicFormBuilderModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BsDropdownModule,
    InfoIconComponent,
    RouterModule,
    NgbModule,
    NgScrollbarModule,
    ModalModule.forRoot(),
    BsDatepickerModule,
    ImageCropperModule,
    TabsModule.forRoot(),
    AccordionModule.forRoot(),
    NgSelectModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgxAudioPlayerModule,
    TypeaheadModule.forRoot(),
    InfiniteScrollModule,
    NgIvsModule,
    ShareIconsModule,
    ShareButtonsModule.withConfig({
      debug: true,
      prop: shareProp
    }),
    CarouselModule,
    NgxIntlTelInputModule,
    MentionModule,
    AlertModalComponent,
    SkeletonComponent,
    TableSkeletonComponent,
    CardGridSkeletonComponent,
    EventTicketingSkeletonComponent,
    MerchandiseDetailsSkeletonComponent,
    GiftDetailsSkeletonComponent,
    ProfileSkeletonComponent,
    RightSidebarSkeletonComponent,
    FollowersFollowingsSkeletonComponent,
    ResourceCardGridSkeletonComponent,
    OrderPaymentSkeletonComponent,
    DynamicListingComponent,
    FormTextAreaComponent,
    ProfileDetailComponent,
    NftUnlockModalComponent,
    SubscriptionSelectModalComponent,
    SubscriptionPlanDurationModalComponent,
    ButtonComponent,
    PriceDiscountPipe,
    TabViewComponent,
    ImageCropperComponent,
    NgxMaterialTimepickerModule,
    ConfirmationModalComponent,
    NgOtpInputModule,
    CustomMultiSelectComponent,
    ImageOverlayComponent,
    MobileInputComponent,
    PhoneMaskDirective,
    CircleBackgroundIconComponent,
    VenueAddressDisplayComponent,
    BookDemoComponent,
    DynamicFormBuilderModule,
    ColorPickerModule,
    TextEditorV2Component,
    PickerModule,
    PostAudioIconComponent,
    SearchBarV2Component,
    ToolTipDirective,
    CurrencyToLocal,
    PriceDisplayComponent,
    IsDeductionTransactionPipe,
    LoyaltyOnlyWarningModalComponent,
    DisableRightClickDirective,
    MobileOptimizationDirective,
    LanguageSwitcherComponent,
    NgCircleProgressModule.forRoot({})
  ],
  exports: [
    PluralizePipe,
    LoginOrGuestDialogComponent,
    HeaderComponent,
    HeaderUserMenuComponent,
    LanguageSwitcherComponent,
    SidebarComponent,
    FooterComponent,
    RightSidebarComponent,
    InfoIconComponent,
    DynamicFormBuilderModule,
    FormsModule,
    SharedPhoneMaskDirective,
    NgbModule,
    BsDropdownModule,
    ProfileSidebarComponent,
    UserImageComponent,
    UserProfileComponent,
    ReactiveFormsModule,
    LoaderComponent,
    ConvertDate,
    PostLiked,
    AudioPlayer,
    BsDatepickerModule,
    FollowStatus,
    PollAnswered,
    StripeFormComponent,
    MyProfile,
    isPostCollaboratorPipe,
    ProfileComponent,
    CustomSlicePipe,
    CourseDetailSidebarComponent,
    InfiniteScrollModule,
    TypeaheadModule,
    CoursesDetailsComponent,
    ExperiencesDetailsComponent,
    MerchandiseDetailsComponent,
    TwoDigitDecimaNumberDirective,
    BioFormatPipe,
    MakeTagTextPipe,
    MakeTagTextWithAdminTagPipe,
    VideoPlayerComponent,
    VideoPlayerV2Component,
    VideoPlayerV3Component,
    VideoOption,
    UserNameToLink,
    SearchedPostListComponent,
    ScheduleTime,
    PostScheduled,
    TabsModule,
    ModalModule,
    NoSpaceDirective,
    BlockedUserStatus,
    FluidHeightPipe,
    CarouselModule,
    AtTaggingUserComponent,
    AtHashtagComponent,
    CheckIsURL,
    ContentLengthHandlerPipe,
    FilterPipe,
    SafeUrl,
    NgScrollbarModule,
    PriceDiscountPipe,
    UserTimeZone,
    NgxIntlTelInputModule,
    RemoveURLS,
    MentionModule,
    EventListItemComponent,
    IntersectionObserverDirective,
    ReadMoreDirective,
    MobileBridgeFileInputDirective,
    UnlockContentComponent,
    PortfolioUnlockModalComponent,
    GiveawayResponseModal,
    ButtonComponent,
    HasPermissionPipe,
    TabViewComponent,
    TickIconComponent,
    InfoIconComponent,
    TranslateDirective,
    HasArrayValuePipe,
    PostSubmitComponent,
    CurrencyConversionPipe,
    DownloadableDetailsComponent,
    ImageCropperComponent,
    ScheduleComponent,
    CreatorRequirementsModalComponent,
    LinkifyPipe,
    DisableRightClickDirective,
    AudioSliderPatchDirective,
    SpaLinkDirective,
    ScrollContainerLoaderDirective,
    ToolTipDirective,
    ConfirmationModalComponent,
    TimerFormat,
    VerifyOTPModalComponent,
    CustomMultiSelectComponent,
    CircleBackgroundIconComponent,
    CustomWelcomeModalTemplate,
    CommentsComponent,
    LikeShareBarComponent,
    PostCardComponent,
    ImageOverlayComponent,
    AlertModalComponent,
    LoginDialogComponent,
    SkeletonComponent,
    TableSkeletonComponent,
    CardGridSkeletonComponent,
    AbbreviateNumberPipe,
    DiscountCodeModal,
    ColorPickerModule,
    TextEditorV2Component,
    WatermarkControlsComponent,
    LoyaltyOnlyWarningModalComponent,
    MerchandiseShareModalComponent,
    CustomBenefitsModalComponent,
    ShareDetialsPreviewComponent,
    CameraModalComponent,
    ChatCommentsComponent,
    CustomizeExperienceComponent,
    TicketCustomerInformationComponent,
    ScheduleExperienceComponent,
    OrderPaymentComponent,
    PaymentIntentCheckoutComponent,
    ShippingOptionsComponent,
    BookDemoComponent,
    MobileOptimizationDirective,
    PickerModule,
    MinimumTipComponent,
    FeedContentShareModalComponent,
    EventTicketingShareModalComponent,
    VipOfferShareModalComponent,
    PortfolioShareModalComponent,
    PostAudioIconComponent,
    FundraiserProgressSectionComponent,
    PaymentSuccessfulModalComponent,
    ItemClaimedModalComponent,
    FundContributeModalComponent,
    ViewContributorsModalComponent,
    UserGroupsModalComponent,
    GiftDetailsModalComponent,
    PollOptionsComponent,
    PurchasePointsModalComponent,
    UnlockWithPointsModalComponent,
    SponsoredAdComponent,
    UpcomingEventCountdownComponent,
    SkyscraperPreviewModalComponent,
    TopicTagsSelectionComponent,
    BadgeGroupsSelectionComponent,
    UserTypeSelectionModalComponent,
    CapitalizeFirstPipe,
    ShowTabByApprovalPipe,
    AddressFormattingPipe,
    VenueAddressDisplayComponent,
    CurrencyToLocal,
    PriceDisplayComponent,
    IsDeductionTransactionPipe,
    CurrencyConversionModalComponent,
    TicketDetailsDisplayComponent,
    TicketViewModalComponent
  ],
  entryComponents: [
    PostSubscriptionListPopupComponent
  ],
  providers: [
    { provide: MAT_BOTTOM_SHEET_DATA, useValue: {} },
    SharedPhoneMaskDirective,
    MyProfile,
    isPostCollaboratorPipe,
    DatePipe,
    AbbreviateNumberPipe,
    CapitalizeFirstPipe,
    CurrencyToLocal,
    IsDeductionTransactionPipe,
    ShowTabByApprovalPipe,
    AddressFormattingPipe
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {
  constructor(iconLibrary: FaIconLibrary) {
    iconLibrary.addIcons(faXTwitter, faCommentSms);
  }
}